<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <vs-row class="w-25">
          <vs-col vs-w="8"></vs-col>

          <vs-col vs-w="2">
            <vs-button
              id="translate-form"
              class="mr-2 w-100"
              icon="send"
              color="warning"
              @click="translate()"
              >Translate</vs-button
            >
          </vs-col>
          <vs-col vs-w="2">
            <vs-button
              id="add-service-form"
              class="mr-2 w-100"
              icon="add"
              color="primary"
              @click="openAddCustomerPrompt()"
              >{{ $t("Service.AddServiceButton") }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-card>

      <vs-card>
        <div slot="header"></div>
        <vs-tabs>
          <!-- ALL Services TAB -->

          <vs-tab
            :label="$t('Customer.Tabs.All')"
            icon="list_alt"
            id="all-tab"
            @click="showAll"
          >
            <vs-table
              :sst="true"
              @search="handleSearch"
              @selected="handleSelected"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="services"
            >
              <template slot="thead">
                <vs-th sort-key="id">{{ $t("Service.Table.Id") }}</vs-th>
                <vs-th sort-key="title">{{ $t("Service.Table.Title") }}</vs-th>
                <vs-th sort-key="description">{{
                  $t("Service.Table.Description")
                }}</vs-th>
                <vs-th sort-key="industry_id">{{
                  $t("Service.Table.Industry")
                }}</vs-th>
                <vs-th sort-key="created_at">{{
                  $t("Service.Table.CreatedAt")
                }}</vs-th>
                <vs-th>{{ $t("Customer.Table.Options") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].description">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].id }}
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].title">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">{{ data[indextr].title }}</h5>
                        <span class="text-muted">{{
                          data[indextr].title
                        }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].description }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].industry_id">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{
                        data[indextr].industry_id
                      }}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].created_at }}
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                        radius
                        color="danger"
                        type="border"
                        icon="delete"
                        @click="deleteService(data[indextr])"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <!--pagination-->
            <vs-pagination
              @change="handleChangePage"
              :total="totalPages"
              v-model="currentPage"
            ></vs-pagination>
          </vs-tab>

          <!-- BY INDUSTRY -->

          <vs-tab label="By Industry" icon="check_box" id="approved-tab">
          </vs-tab>

          <!-- BY  SUB INDUSTRY -->

          <vs-tab label="By SubIndustry" icon="check_box" id="approved-tab">
          </vs-tab>
        </vs-tabs>
      </vs-card>
      <CustomizerSidebar
        v-if="selected"
        ref="Customizer"
        :selectedService="selected"
        :service_tab="true"
        @hide="hide"
        sideBarTitle="Service "
      ></CustomizerSidebar>

      <CustomizerSidebar
        ref="AddService"
        @hide="hide"
        :service_new="true"
        :sideBarTitle="$t('Service.AddServiceButton')"
      ></CustomizerSidebar>
    </vs-col>
  </vs-row>
</template>

<script>
import { businessService, serviceServices } from "../../_services";
import CustomizerSidebar from "../../layout/full/customizer/CustomizerSidebar.vue";

import router from "../../_helpers/router";
// moment

export default {
  name: "Customers",
  data: () => ({
    title: "Customers",
    activePrompt: false,
    activeDeletePrompt: false,
    activeUpdatePrompt: false,
    activeBookPrompt: false,
    activeUploadPrompt: false,
    activeApprovalPrompt: false,
    businesses: [],
    services: [],
    approvedBusinesses: [],
    disapprovedBusinesses: [],
    selected: {},
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    totalApprovedPages: 0,
    currentApprovedPage: 1,
    totalDisapprovedPages: 0,
    currentDisapprovedPage: 1,
    maxItems: 0,
    importModal: {
      file: null,
    },

    errors: {
      firstName: false,
      lastName: false,
      email: false,
      phoneNumber: false,
      libID: false,
      selected: {
        firstName: false,
        lastName: false,
        email: false,
        phoneNumber: false,
        libID: false,
      },
    },
    fname: "",
    lname: "",
    phone_number: "",
    address: "",
    email: "",
    notes: "",
    internalId: "",
    dateOfBirth: "",
    searchKeyword: "",
  }),
  methods: {
    deleteService(service) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Supprimer Service",
        text: `Voulez vous vraiment supprimer le service "${service.title}"`,
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          this.showLoading();
          serviceServices
            .deleteService(service.id)
            .then(
              function() {
                this.handleChangePage(this.currentPage);
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Kiosk.ResetSecretPrompt.ToastSuccess"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Kiosk.ResetSecretPrompt.ToastFail"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
              }.bind(this)
            );
        }.bind(this),
      });
    },
    handleSearch(keyword) {
      this.showLoading();
      this.searchKeyword = keyword;
      if (keyword == "") {
        serviceServices
          .getPage(1)
          .then(
            function(data) {
              this.services = data.services.data;
              this.totalItems = data.services.total;
              this.maxItems = data.services.per_page;
              this.totalPages = data.services.last_page;
            }.bind(this)
          )
          .finally(
            function() {
              this.hideLoading();
            }.bind(this)
          );
      }
      serviceServices
        .search(keyword, 1)
        .then(
          function(data) {
            this.services = data.services.data;
            this.totalItems = 10;
            this.maxItems = 1;
            this.totalPages = 2;
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
          }.bind(this)
        );
    },

    translate() {
      this.showLoading();
      businessService
        .translate()
        .then(
          function(data) {
            this.notify(
              this.$t("Toasts.Successful"),
              "Services translated",
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(this.$t("Toasts.Error"), "Services fail", "danger");
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
          }.bind(this)
        );
    },

    handleChangePage(page) {
      this.showLoading();
      serviceServices
        .getPage(page)
        .then(
          function(data) {
            this.services = data.services.data;
          }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
        });
    },

    openAddCustomerPrompt() {
      this.$refs.AddService.show();
    },
    hide() {
      this.$emit("hide", "hide");
    },
    Closed() {
      this.$vs.notify({
        color: "danger",
        title: "Delete Cancel",
        text: "Cancelling!",
      });
    },
    handleSelected() {
      /* eslint-disable */
      this.selected_customer = this.selected;
      this.$refs.Customizer.show();
    },
    Canceled() {
      this.selected.approved = !this.selected.approved;
      this.$vs.notify({
        color: "danger",
        title: "Approval Cancel",
        text: "Cancelling!",
      });
    },

    deleteCustomers(id) {
      let self = this;
      businessService
        .deleteBusiness(id)
        .then(function(data) {
          self.$vs.notify({
            title: "succes delete",
            text: "account successfully deleted",
            position: "bottom-right",
            type: "success",
            color: "green",
          });
          router.go();
        })
        .bind(this);

      this.activeDeletePrompt = false;
      this.selected = null;
      // this.$router.push('/settings/team');S
    },

    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#customers-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#customers-box > .con-vs-loading");
    },
    reset() {
      this.activePrompt = false;
      this.activeUpdatePrompt = false;
      this.activeBookPrompt = false;
      this.selected = [];
      this.fname = "";
      this.lname = "";
      this.phone_number = "";
      this.address = "";
      this.email = "";
      this.notes = "";
      this.importModal = { file: null };
    },

    showAll() {
      this.services = [];
      this.showLoading();
      serviceServices
        .getAll()
        .then(
          function(data) {
            this.services = data.services.data;
            this.totalItems = data.services.total;
            this.maxItems = data.services.per_page;
            this.totalPages = data.services.last_page;
          }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
        });
    },

    handleChangeApprovedPage(page) {
      this.approvedBusinesses = [];
      this.showLoading();
      businessService
        .getApprovedByPage(page)
        .then(
          function(data) {
            this.approvedBusinesses = data.businesses.data;
          }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  computed: {
    events() {
      return this.$store.state.contactEvents;
    },
    validateAddCustomerForm() {
      // return this.fname.length > 0;
      // return true
    },
  },
  components: {
    CustomizerSidebar,
  },

  mounted() {
    this.showLoading();
    serviceServices
      .getAll()
      .then(
        function(data) {
          this.services = data.services.data;
          this.totalItems = data.services.total;
          this.maxItems = data.services.per_page;
          this.totalPages = data.services.last_page;
        }.bind(this)
      )
      .finally(() => {
        this.hideLoading();
      });
    serviceServices.getAll().then(
      function(data) {
        this.services = data.services;
      }.bind(this)
    );
  },
};
</script>
